<template>
  <div class="success">
    <div class="jumbotron text-center" id="suc">
      <div class="imgg">
        <img src="@/assets/img/cart_.jpg" class="" height="250" width="250" />
      </div>
      <h2><b>Order Summary</b></h2>
      <h3>Your order id: {{ orderId }}</h3>
      <table class="cen">
        <tr>
          <th>PRODUCT</th>
          <th>QUANTITY</th>
          <th>PRICE</th>
        </tr>
        <tr>
          <td id="prod0"></td>
          <td id="prodqty0"></td>
          <td id="prodprice0"></td>
        </tr>
        <tr>
          <td id="prod1"></td>
          <td id="prodqty1"></td>
          <td id="prodprice1"></td>
        </tr>
        <tr>
          <td id="prod2"></td>
          <td id="prodqty2"></td>
          <td id="prodprice2"></td>
        </tr>
        <tr>
          <td id="prod3"></td>
          <td id="prodqty3"></td>
          <td id="prodprice3"></td>
        </tr>
        <tr>
          <td>TOTAL</td>
          <td>--</td>
          <td id="totalPrice"><b></b></td>
        </tr>
      </table>

      <h1 class="display-3">Vielen Dank für Ihren Einkauf!</h1>
      <p class="lead">
        <strong>Überprüfen Sie Ihren E-Mail Ordner</strong> für weitere Details.
      </p>
      <hr />
      <p>
        Haben Sie Probleme?
        <a
          id="coll"
          href=""
          onclick="return tag.click.send({elem:this, name:'kontaktieren-sie-uns', chapter1:'content', chapter2:'text', type:'action'});"
          >Kontaktieren Sie uns</a
        >
      </p>
      <p class="lead">
        <router-link
          class="btn btn-primary"
          :to="'/' + $i18n.locale"
          role="button"
          id="col"
          onclick="return tag.click.send({elem:this, name:'zurueck-zur-startseite', chapter1:'content', chapter2:'text', type:'action'});"
          >Zurück zur Startseite</router-link
        >
      </p>
    </div>
  </div>
</template>
<script>
import emailjs from "@emailjs/browser";

window.onload = function() {
  var a = JSON.parse(window.localStorage.getItem("vuex"));
  var b = a["cartProducts"];
  var i;
  var sum = 0;
  for (i = 0; i < b.length; i++) {
    document.getElementById("prod" + i).innerHTML = b[i].title;
    document.getElementById("prodqty" + i).innerHTML = b[i].qty;
    document.getElementById("prodprice" + i).innerHTML =
      "€ " + String(b[i].price).replace(".", ",");
    sum += b[i].price * b[i].qty;
  }
  document.getElementById("totalPrice").innerHTML = "€ " + Math.round(sum);
};
export default {
  name: "Success",
  data() {
    return {
      orderId: this.generateOrderId(),
    };
  },
  methods: {
    generateOrderId() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    sendEmail() {
      const vuex = JSON.parse(window.localStorage.getItem("vuex"));
      const email = sessionStorage.getItem("emailEmail");
      const name = sessionStorage.getItem("fnameEmail");
      const tableHTML = this.gernateHTML(vuex["cartProducts"]);
      console.log(tableHTML);
      const templateParams = {
        to_name: name,
        order_summary: tableHTML.toString(),
        reply_to: email,
        orderId: this.orderId,
      };
      try {
        emailjs.send(
          "service_7ugvlff",
          "template_oqlf0or",
          templateParams,
          "1_AevTcpxzyDrpuaK"
        );
      } catch (e) {
        console.log({ e });
      }
    },
    gernateHTML(cartProducts) {
      let table =
        '<table border="1" width="100%"><tr style="margin: 0 0 10 0"><th width="35%" style="margin: 0 10 0 0">Produkt</th><th width="20%">Preis</th><th width="20%">Menge</th><th>Gesamtpreis</th></tr>';
      let sum = 0;
      for (let product of cartProducts) {
        const tr = `<tr><td>${product.title}</td><td>${product.price.toFixed(
          2
        )}€</td><td>${product.qty}</td><td>${(
          product.price * product.qty
        ).toFixed(2)}€</td></tr>`;
        table += tr;
        sum += product.price * product.qty;
      }
      table += "</table>";
      table += `<table width="100%" style="margin: 20 0 0 0"><tr><th>Gesamt</th><th>${sum.toFixed(
        2
      )}</th></tr></table>`;
      return table;
    },
  },
  mounted() {
    if (localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    this.sendEmail();
  },
};
</script>
<style scoped>
#col {
  background-color: #1bada2;
}
#coll {
  text-emphasis-color: #1bada2;
}
#suc {
  background-color: white;
  background-image: url("../../assets/img/confetti.png");
}
.cen {
  margin-left: auto;
  margin-right: auto;
}
table {
  border-collapse: collapse;
  width: 40%;
}

th,
td {
  text-align: left;
  padding: 8px;
}

tr {
  background-color: #ffffff;
}

th {
  background-color: #1bada2;
  color: white;
}
</style>
